const kcom = {
  copyright: '© 2019 mov inc.',
  homepage: 'https://mov.am',
  privacy: 'https://kutikomi.com/privacy_policy/',
  terms: 'https://kutikomi.com/user_terms/',
  contact: 'https://kutikomi.com/contact/',
  help: 'https://movinc.notion.site/03d80ef53c334234807407353579d844',
  photos_policy: 'https://movinc.notion.site/8745c36f1f6c4eda87b969c71abb83e8#9c32719397464ffc9bbb89c915cd30d4'
}

const localone = {
  copyright: '©ONE COMPATH CO., LTD. All rights reserved.',
  homepage: 'https://onecompath.com/',
  privacy: 'https://onecompath.com/privacy/',
  terms: 'https://localone.jp/policies/terms.html',
  contact: 'https://localone.jp/inquiry/admin.html',
  help: 'https://localone.jp/help/',
  photos_policy: 'https://support.google.com/business/answer/10693375' // todo: 一旦Googleのポリシーを表示する
}

const retty = {
  copyright: 'Copyright (C) Retty, Inc. All Rights Reserved.',
  homepage: 'https://retty.me/',
  privacy: 'https://retty.me/announce/privacy/',
  terms: 'https://drive.google.com/file/d/1Uej7RJwvcotIcx7b6kWWrYZbZYqeYQUn/view',
  contact: 'https://retty.me/',
  help: 'https://docs.google.com/presentation/d/e/2PACX-1vSRw6C2i49bP78-4DHkh39CAYqfVGXsjRIJlqOrghy-BrfBF18Hx9tDbwugZNW_CAmdGUYMV4g4sKZo/pub?start=false&loop=false&delayms=3000&slide=id.g27eb019fdc7_0_1190',
  photos_policy: 'https://retty.me/'
}

export const allServiceUrlConst = {
  'kcom': kcom,
  'localone': localone,
  'retty': retty
}
